var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19.429,
  height: 19.429,
  x: 0.285,
  y: 0.285,
  fill: "url(#clock_svg__a)",
  rx: 9.715
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 19.429,
  height: 19.429,
  x: 0.285,
  y: 0.285,
  stroke: "#2C3E50",
  strokeWidth: 0.571,
  rx: 9.715
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C3E50",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.141,
  d: "M9.781 4.783v5.351l3.71 3.78"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock_svg__a",
  x1: 0.238,
  x2: 20.238,
  y1: 10,
  y2: 10,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEEF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E5F8FF"
})))));
export default SvgClock;